import { render, staticRenderFns } from "./_upload_new_version_link.vue?vue&type=template&id=53926df2&scoped=true&"
import script from "./_upload_new_version_link.vue?vue&type=script&lang=js&"
export * from "./_upload_new_version_link.vue?vue&type=script&lang=js&"
import style0 from "./_upload_new_version_link.vue?vue&type=style&index=0&id=53926df2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53926df2",
  null
  
)

export default component.exports